export const AWS_INTEGRATION = {
  TITLE: 'Connect your AWS accounts',
  STEP1: {
    HELPER_TAG: 'Choose if you want to integrate one or multiple accounts',
    SINGLE_ACCOUNT: {
      TITLE: 'Single AWS account',
      DESCRIPTION: 'If you manage everything from a single AWS account.',
    },
    MULTI_ACCOUNT: {
      TITLE: 'Multiple AWS accounts',
      DESCRIPTION: 'For AWS Organizations or multi accounts setups',
    },
  },
  STEP2_SINGLE: {
    HELPER_TAG: 'Provide your AWS account metadata to start the process.',
    ACCOUNT_ID_LABEL: 'AWS account ID',
    ACCOUNT_ID_HELPER: '12-digit numeric ID',
    ACCOUNT_ID_ERROR: 'Please enter your AWS account ID',
    ACCOUNT_ID_FORMAT_ERROR: 'AWS account ID must be a 12-digit number',
    ACCOUNT_NAME_LABEL: 'Account display name',
    ACCOUNT_NAME_HELPER: 'Used inside Qalea',
    ACCOUNT_NAME_ERROR: 'Please enter an account display name',
  },
  STEP2_MULTI: {
    HELPER_TAG: 'Describe the AWS accounts you want to manage through StackSets.',
    ACCOUNT_ID_LABEL: 'Account ID',
    ACCOUNT_NAME_LABEL: 'Account name',
    ADD_ACCOUNT: 'Add another account',
    AT_LEAST_ONE_ACCOUNT_ERROR: 'Please enter at least one account with ID and name',
    ORGANIZATION_ID_LABEL: 'AWS Organizations root / OU ID',
    ORGANIZATION_ID_HELPER: 'Used as deployment target',
    ORGANIZATION_ID_ERROR: 'Please enter your organization root or OU ID',
    ORGANIZATION_ID_PLACEHOLDER: 'r-examplerootid / ou-exam-pleouid',
    ORGANIZATION_ID_HELP_LINK: 'check it here',
  },
  STEP3_SINGLE: {
    HELPER_TAG: "Verify the account below. You'll be redirected to AWS with a preconfigured CloudFormation stack.",
  },
  STEP3_MULTI: {
    HELPER_TAG: 'Run these commands using the AWS CLI with StackSets prerequisites in place.',
    STEP_1_TITLE: 'Create the StackSet',
    STEP_2_TITLE: 'Deploy the StackSet instances',
    ALT_INFO_TITLE: 'Not using StackSets?',
    ALT_INFO_ITEM_1: 'Create stacks directly in each account using the',
    ALT_INFO_LINK_TEMPLATE: 'CloudFormation template',
    ALT_INFO_OR: 'or',
    ALT_INFO_LINK_GUIDE: 'installation guide',
    ALT_INFO_ITEM_2: 'Ensure the',
    ALT_INFO_LINK_PREREQS: 'StackSets prerequisites',
    ALT_INFO_ITEM_2_SUFFIX: 'are met (trusted access, IAM roles).',
  },
  FOOTER: {
    CANCEL: 'Cancel',
    CONTINUE: 'Continue',
    BACK: 'Back',
    GENERATE_CLI: 'Generate CLI instructions',
    OPEN_AWS: 'Open AWS',
    DONE: 'Done',
  },
  STEP_PROGRESS_SINGLE: {
    STEP_1: 'Account Type',
    STEP_2: 'Account Details',
    STEP_3: 'Review & Connect',
  },
  STEP_PROGRESS_MULTI: {
    STEP_1: 'Account Type',
    STEP_2: 'Account Details',
    STEP_3: 'CLI Instructions',
  },
}
